import { createContext } from 'react';
import type { Control, FieldErrorsImpl } from 'react-hook-form';
import { IncompleteRegisterFormData } from './types';

interface FormContextProps {
  control: Control<IncompleteRegisterFormData>;
  errors: Partial<
    FieldErrorsImpl<{
      [x: string]: any;
    }>
  >;
}

export const FormContext = createContext<FormContextProps>({
  control: {} as Control<IncompleteRegisterFormData>,
  errors: {}
});
